import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../../hooks/useLanguage';

const ReactMarkdown = require("react-markdown");


const HomeAboutArticle = ({ aboutData }) => {
  const langToggle = useLanguage;
  return (
    <article className="home-about__article">
         <ReactMarkdown source={langToggle(aboutData.description_ua, aboutData.description_ru)} />  
    </article>
  );
};

HomeAboutArticle.propTypes = {
  aboutData: PropTypes.object,
};

export default HomeAboutArticle;
